<app-deprecated-confirmation-dialog
    #confirmDeleteTaskTemplateDialog
    label="delete"
    description="employees.settingsOffboarding.deleteDescription"
    [negative]="true"
></app-deprecated-confirmation-dialog>

<!-- Body -->
<div class="page-container">
    <app-header
        title="{{ 'employees.settingsOffboarding.people' | translate }}"
        [menuService]="employeeModuleMenuService"
    >
        <div class="buttons" *ngIf="hasTaskPermission">
            <ui-button type="primary" (click)="onNewTask($event)"
                ><mat-icon svgIcon="plus"></mat-icon
                >{{ 'employees.settingsOffboarding.createTaskTemplate' | translate }}</ui-button
            >
        </div>
    </app-header>

    <div class="taskTemplates">
        <!--show table if there are tasks-->
        <app-table [table]="table" (menuItemSelected)="onTableMenuEvent($event)">
            <div class="empty">
                <h2 class="ui centered header">
                    <ng-container *ngIf="table.hasFiltersApplied(); else emptyState"
                        >{{ 'employees.settingsOffboarding.noTaskTemplates' | translate }}
                    </ng-container>
                    <ng-template #emptyState
                        >{{ 'employees.settingsOffboarding.noOffboardingTask' | translate }}
                    </ng-template>
                </h2>
            </div>
        </app-table>
    </div>
</div>
